/* eslint-disable import/named */

import React from 'react'
import Link from 'next/link'
import assetLoader from '@utils/internalImageLoader'
import Image from 'next/image'
import { IconWrap } from '@styles/commonStyles'
import { TopicItem } from './styles'

const TopicItems = ({ topic }) => (
  <TopicItem key={topic?.id}>
    <picture>
      <source srcSet={topic?.attributes?.image?.data?.attributes?.url} type="image/svg+xml" />
      <source srcSet={`${topic?.attributes?.image?.data?.attributes?.url}?fm=webp`} type="image/webp" />
      <Image
        src={topic?.attributes?.image?.data?.attributes?.url}
        alt={topic?.attributes?.image?.data?.attributes?.alternativeText}
        width="28"
        height="28"
      />
    </picture>
    <Link href={`/articles/${topic?.attributes?.url}/`}>
      <p>{topic?.attributes?.topicName}</p>
    </Link>
    <IconWrap>
      <Image
        src={`${assetLoader()}/images/arrow-right.svg`}
        alt="Icon"
        width="20"
        height="20"
        className="icon"
        layout="fixed"
      />
    </IconWrap>
  </TopicItem>
)

export default TopicItems
